import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

const AuthCallbackPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const token = searchParams.get('token');
        const userData = searchParams.get('user');
        const error = searchParams.get('error');

        if (error) {
          console.error('Authentication error:', error);
          navigate('/login?error=' + encodeURIComponent(error));
          return;
        }

        if (token && userData) {
          const user = JSON.parse(decodeURIComponent(userData));
          await login(token, user);
          navigate('/dashboard');
        } else {
          console.error('Missing token or user data in callback');
          navigate('/login?error=missing_data');
        }
      } catch (error) {
        console.error('Error processing auth callback:', error);
        navigate('/login?error=callback_error');
      }
    };

    handleAuthCallback();
  }, [searchParams, login, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      gap={2}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" color="text.secondary">
        Completing authentication...
      </Typography>
    </Box>
  );
};

export default AuthCallbackPage;
